import luxTheme from './luxuryescapes'

const theme: App.Theme = {
  ...luxTheme,
}

export default theme
